import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
// import CheckCircle from 'react-icons/lib/fa/check-circle'
// import _ from 'lodash'

import Text from 'components/common/Text'
import Card from 'components/shared/Card'
import { BLUE, PURPLE } from 'components/styles'

const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
`
const IconSelected = styled.div`
  position: absolute;
  top: 40%;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  color: ${BLUE};
`
const Title = styled.div`
  position: absolute;
  text-align: center;
  line-height: 0.5;
  width: 100%;
  bottom: 5px;
  background-color: rgba(234, 247, 255, 0.59);
`
const StoreImageContainer = styled.div`
  position: absolute;
  background-color: rgba(234, 247, 255, 1);
  top: 0em;
  right: 0em;
  width: 1.5em;
  height: 1.5em;
`
const SelectedTextContainer = styled.div`
  background-color: rgba(251, 251, 251, 0.9);
  padding: 3px 8px 3px;
  border-radius: 5px;
  color: #000;
`


class ProductCard extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overlayVisible: false
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { imageUrl, isSelected, title } = this.props
    const imageUrlChanged = imageUrl !== nextProps.imageUrl
    const isSelectedChanged = isSelected !== nextProps.isSelected
    const titleChanged = title !== nextProps.title
    const overlayVisibleChanged = this.state.overlayVisible !== nextState.overlayVisible
    return imageUrlChanged || isSelectedChanged || titleChanged || overlayVisibleChanged
  }

  onClick = (e) => {
    const { onClick } = this.props
    onClick(e)
  }

  renderStoreIcon = () => {
    const { storeIcon } = this.props
    if (storeIcon) {
      return (
        <StoreImageContainer>
          <Image src={storeIcon} />
        </StoreImageContainer>
      )
    }
  }

  renderSelected = () => {
    return (
      <IconSelected>
        <SelectedTextContainer>
          <Text>Selected</Text>
        </SelectedTextContainer>
      </IconSelected>
    )
  }

  render () {
    const { imageUrl, isSelected, title, overlay } = this.props
    const { overlayVisible } = this.state
    const eventListeners = {
      onMouseEnter: () => this.setState({overlayVisible: true}),
      onMouseLeave: () => this.setState({overlayVisible: false})
    }
    return (
      <Card
        onClick={this.onClick}
        eventListeners={eventListeners}
        pointer
        styleRaw={isSelected ? `border: 2px ${PURPLE} solid;` : ''}
      >
        <Image
          src={imageUrl}
          role={'presentation'}
        />
        {isSelected && this.renderSelected()}
        {/* {isSelected &&
          <IconSelected>
            <CheckCircle style={{backgroundColor: 'white', borderRadius: 12, width: 24, height: 24}} />
          </IconSelected>
        } */}
        <Title>
          <Text size='medium'>{title}</Text>
        </Title>
        {this.renderStoreIcon()}
        {overlayVisible ? overlay : null}
      </Card>
    )
  }
}

ProductCard.defaultProps = {
  onClick: () => null,
  isSelected: false,
  title: '',
}

ProductCard.propTypes = {
  onClick: PropTypes.func,
  imageUrl: PropTypes.string,
  isSelected: PropTypes.bool,
  title: PropTypes.string,
  overlay: PropTypes.element,
  storeIcon: PropTypes.string
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/components/editor/productCards/ProductCard.js